/**
 * Sprint 30 · Nav catalogue — the two sections the mega-menu renders:
 *   • Product Categories (12 clickable parent links; 5 new hubs + existing)
 *   • Sourcing Services (9 clickable service links)
 * Every entry maps to an EXISTING indexed URL (no new routes beyond the
 * 5 Sprint-30 hubs). Garments & Apparel intentionally omitted — Asia Sourcing
 * explicitly does not source apparel; Fashion Accessories covers that space.
 */
export const NAV_PRODUCT_CATEGORIES = [
  { to: "/categories/lighting", label: "Lighting" },
  { to: "/categories/furniture", label: "Furniture" },
  { to: "/categories/home-decor", label: "Home Décor" },
  { to: "/categories/textile", label: "Textiles & Soft Furnishings" },
  { to: "/categories/fashion-accessories", label: "Fashion Accessories" },
  { to: "/categories/brass-metalware", label: "Brass & Metalware" },
  { to: "/categories/tabletop-dining", label: "Tabletop & Dining" },
  { to: "/categories/candles-home-fragrance", label: "Candles & Home Fragrance" },
  { to: "/categories/garden-outdoor", label: "Garden & Outdoor" },
  { to: "/categories/bathroom-wellness", label: "Bathroom & Wellness" },
  { to: "/categories/seasonal-decor", label: "Seasonal Décor" },
];

export const NAV_SOURCING_SERVICES = [
  { to: "/services/buying-house-india", label: "Product Sourcing" },
  { to: "/services/supplier-verification-india", label: "Supplier Verification" },
  { to: "/services/quality-control-india", label: "Quality Control & Inspection" },
  { to: "/services/product-development-india", label: "Product Development" },
  { to: "/services/factory-audit-india", label: "Factory Audits" },
  { to: "/services/private-label-manufacturing-india", label: "Private Label & OEM Manufacturing" },
  { to: "/services/quality-inspection-india", label: "Compliance & Sustainability" },
  { to: "/services/supply-chain-management-india", label: "Supply Chain Management" },
  { to: "/services/strategic-sourcing-india", label: "Strategic Sourcing" },
];
